import type { FaireProductEntity } from "../../entity_types/product";

export const p_spy7twrxnz: FaireProductEntity = {
  token: "p_spy7twrxnz",
  type: "product",
  name: "Ethically Sourced CELESTITE Crystal Clusters, Bulk Crystals",
  brandToken: "b_fak8czuqg9",
  brandName: "Mandala Gems",
  imageUrl:
    "https://cdn.faire.com/fastly/31ed1c88812a2738059534474ee7c9df51d24d333de8ac89ddbeff00536200a8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6e5363c230d744fb505b94e79fafb068c5c2625acf2f26601e1aa8444d8aecc.jpeg",
    "https://cdn.faire.com/fastly/967b47f1c24bdcdba9f4f2d0c9f6339b4361dadd55ba0a1c05f31fd023a4bd0c.jpeg",
    "https://cdn.faire.com/fastly/1f7bfda5e53ff9272b37cbfe1ba5db2d51913830fc30ce79dc42c056ea3030cd.jpeg",
    "https://cdn.faire.com/fastly/ede5217608e97bea18f27da889fcfec849fe36540dcbf360e3f96e56b4ff959d.jpeg",
    "https://cdn.faire.com/fastly/10399b8bcec24fb40a3e20e03dabfa7704a9dfb07e8cb55d6e9ff504472bbd27.jpeg",
    "https://cdn.faire.com/fastly/cec5c2d3637c4bacb5f98a56d8dbec7801ea736b440603b7a4c75b9f2fcd5e9b.jpeg",
    "https://cdn.faire.com/fastly/03d4b6ed53066f127870aeea6ab7dc7abd440764ff45a6e15c7d40d7e84980ad.jpeg",
    "https://cdn.faire.com/fastly/72e70c43a6a462ef0411723095168c552e7a35923cdc93ce001a8cc44e10ec6f.jpeg",
  ],
  priceDollars: 3,
  description:
    "Celestite Clusters – Natural Blue Crystal Geodes\n\nThese are the ones people come back for.\n\nFor over a decade, celestite has quietly remained our best-selling crystal. Not the flashiest, not the loudest, but the one customers remember, the one they return to replace, gift, or finally claim after thinking about it for weeks.\n\nEach cluster formed in a hollow space where mineral-rich water slowly retreated and left blue light behind. The crystal points grow inward, creating a small sky you can look into. Some feel like frost, others like distant horizon, all carrying the same calm presence that makes people pause mid-conversation.\n\nThey don’t demand attention.\nThey soften a space.\n\nRetail appeal:\n• Proven long-term bestseller (10+ years)\n• Immediate emotional connection for customers\n• Ideal gift crystal across age groups\n• Easy to merchandise singly or grouped\n\nPerfect for:\n– Bedside displays\n– Quiet corners\n– Gift shelves\n– Spaces meant to feel gentle\n\nEach piece varies in depth of blue, sparkle, and interior landscape.\nA crystal people rarely forget after holding once.",
  tags: [],
  msrpDollars: 6,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:30.993Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
